module.exports = __webpack_public_path__ + "bradavice_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_7_before.jpg
// module id = 942
// module chunks = 0